// extracted by mini-css-extract-plugin
export default {"recos":"c1-z","productCardOverride":"d1-z","rowHasBadge":"e1-z"};